import { CommercialProductsRepository } from '@Commercial/Products/Data/Repository/ProductRepository'

export interface DeletePriceRange {
    execute(id: string): Promise<void>
    getSource(): string
}

export class DeletePriceRangeUseCase implements DeletePriceRange {
    constructor(private repository: CommercialProductsRepository) {}
    async execute(id: string) {
        return this.repository.deletePriceRange(id)
    }
    getSource(): string {
        return this.repository.dataSource.getSource()
    }
}
